import React from 'react'
import { injectIntl, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import TermsField from 'commons/js/ui/TermsField'
import Routes from 'commons/js/routes/routes'
import { checked } from 'commons/js/util/validators'
import messages from './messages'

class AcceptConditionsField extends React.Component {
    static propTypes = {
        intl: PropTypes.object,
    }

    static defaultProps = {
        isLoggedIn: false,
    }

    render () {
        return (
            <TermsField
              dataTest='contact-form-acceptConditionsContactForm'
              fontSize='xSmall'
              id='.acceptConditionsContactForm'
              model='.acceptConditionsContactForm'
              validators={{
                  checked: checked(),
              }}
              errorMessages={{
                  checked: this.props.intl.formatMessage(messages.requiredError),
              }}
              renderTermsLink={() =>
                  <a rel='noopener noreferrer' href={Routes.termsAndConditionsPath()} target='_blank'>
                      <FormattedMessage
                        defaultMessage='términos y condiciones' />
                  </a>
              }
            />
        )
    }
}

export default injectIntl(AcceptConditionsField)
